<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none" :class="customClass" aria-hidden="true"><path fill="#F16A6C" d="M0 5.4h3.857V18H0V5.4ZM5.914 0h3.6v18h-3.6V0Zm5.657 10.286h3.6V18h-3.6v-7.714ZM20.957 5.4H17.1V18h3.857V5.4Z"/></svg>
</template>
<script>
export default {
  data: () => ({
  }),
  props: {
    customClass: {
      type: String,
      required: false
    },
  },
  mounted() {},
  computed: {}
}
</script>
